// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubformNews_wrapper__Cgnd8","main-description":"SubformNews_main-description__jZQsz","photo-description":"SubformNews_photo-description__dZTsC"};